const PASSWORD_SYMBOLS = "!#$%&'()*+,-./:;<=>?@[]_`{|}´°\"\\";

interface NewPasswordRuleResult {
    patternOk: boolean;
    lengthOk: boolean;
    showLengthError: boolean;
    showPatternError: boolean;
}

/**
 * Same rules as the AngularJS validateNewPassword directive.
 * Length is reported only when the character-class rule already passes,
 * because the directive marks length valid whenever the pattern fails.
 */
function evaluateNewPassword(password: string): NewPasswordRuleResult {
    let lower = 0;
    let upper = 0;
    let digit = 0;
    let symbol = 0;

    for (let index = 0; index < password.length; index += 1) {
        const character = password[index];
        if (character >= 'a' && character <= 'z') {
            lower = 1;
        } else if (character >= 'A' && character <= 'Z') {
            upper = 1;
        } else if (character >= '0' && character <= '9') {
            digit = 1;
        } else if (PASSWORD_SYMBOLS.indexOf(character) > -1) {
            symbol = 1;
        }
    }

    const patternOk = (lower + upper + digit + symbol) >= 3;
    const lengthOk = password.length >= 12;

    return {
        patternOk,
        lengthOk,
        showLengthError: !lengthOk && patternOk,
        showPatternError: !patternOk,
    };
}

function passwordsMatch(password: string, confirmation: string) {
    return password === confirmation;
}

export { evaluateNewPassword, PASSWORD_SYMBOLS, passwordsMatch };
export type { NewPasswordRuleResult };
